import React from "react";
import ImportExportIcon from "@mui/icons-material/ImportExport";

interface IAscDescIconProps {}

const AscDescIcon = (props: IAscDescIconProps) => {
  return <ImportExportIcon className="icon" />;
};

export default AscDescIcon;
